<template>
    <div class="comminHeader">

        <div class="content">

            <!-- 标题 -->
            <div class="title">张家口市桥东区知识产权运营服务平台</div>

            <!-- 用户 -->
            <div class="user_box">
                
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-back" @click.native="loginOut">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>

        </div>

    </div>
</template>

<script>
import '../styles/comminHeader.scss'
import cookie from "../static/cookie";
export default {
    data() {
        return {
            userName: ''
        }
    },
    created() {
        this.userName = this.getItem("userName", '管理员')
    },
    methods: {
        loginOut() {
            this.$confirm('确定要退出吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {
                cookie.delCookie('token');
                // this.removeItem('userName')
                this.$message({
                    message: '退出成功',
                    type: 'success'
                });
                // this.$router.push({path: '/login'})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消退出'
                });  
            })
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/comminHeader.vue